export const financial = {
	periodLabel: "({{since}} hasta {{until}})",
	filters: {
		income: "Ingreso",
		average: "Ticket promedio",
		bonus: "Bono",
	},
	methodFilters: {
		total: "Promedio",
		zigCredit: "Crédito Zigpay",
		zigDebit: "Débito Zigpay",
		credit: "Crédito",
		debit: "Débito",
		cash: "Efectivo",
	},
	income: {
		label: "Comparar con",
		labelChart: " Facturado",
	},
	ticket: {
		average: " Ticket Promedio",
		real: " Ticket Real",
	},
	bonus: {
		label: " Bono",
	},
	graphCards: {
		paymentMethod: {
			label: "Métodos de pago",
			subtitle: "Valor facturado por método de pago durante el período {{periodLabel}}",
			zigCredit: "Crédito Zigpay",
			zigDebit: "Débito Zigpay",
			credit: "Crédito",
			debit: "Débito",
			cash: "Efectivo",
			postEvent: "Después del evento",
			voucher: "Voucher",
			anticipated: "Anticipado",
			dashboard: "Dashboard",
			app: "Aplicación",
			others: "Otros",
			uniformed: "No informado",
		},
		billingsPerPeriod: {
			label: "Días con mayores ingresos",
			subtitle: "Valor facturado por día de la semana durante el período {{periodLabel}}",
		},
		averageTicket: {
			label: "Récords de ticket promedio",
			subtitle: "Valor facturado por día durante el período {{periodLabel}}",
		},
		bonusPerWeek: {
			label: "Días de la semana con más bonos",
			subtitle: "Valor bonificado por día durante el período {{periodLabel}}",
		},
		billingsPerWeekDay: {
			label: "Días de la semana con mayores ingresos",
			subtitle:
				"Valor promedio facturado por día de la semana durante el período {{periodLabel}}",
		},
		averageTicketPerWeekDay: {
			label: "Días de la semana con mayores tickets promedio",
			subtitle:
				"Valor promedio del Ticket Promedio por día de la semana durante el período {{periodLabel}}",
		},
		highestBonus: {
			label: "Mayores bonificaciones",
			subtitle: "Valor bonificado por día durante el período {{periodLabel}}",
		},
		consumptionTime: {
			label: "Total de venta por horario",
			subtitle: "Período: {{periodLabel}}",
			filename: "total_de_venta_por_horario",
			formatPeriod: {
				nextPeriod: "{{currPeriod}} hasta {{nextPeriod}}",
				currPeriod: "a las {{currPeriod}}",
			},
			tooltip: {
				dates: "Total consumido de {{since}} hasta {{until}}:",
				date: "Total consumido a las {{date}}",
			},
			columns: {
				period: "Período",
				sunday: "Domingo",
				monday: "Lunes",
				tuesday: "Martes",
				wednesday: "Miércoles",
				thursday: "Jueves",
				friday: "Viernes",
				saturday: "Sábado",
				general: "General",
			},
		},
	},
	financialChartCards: {
		averageTicket: "Ticket Promedio",
		average: " Promedio",
		billing: "Facturación",
		bonus: "Bono",
	},
};
